import {getAssetPath} from "@stencil/core";

export function serverAddress(): string {
	if (location.hostname === 'localhost') {
		const port = location.port !== '3333' ? location.port : '8080';
		return `http://localhost:${port}`;
	} else {
		const path = getAssetPath('..');
		return path !== '/' && path.endsWith('/') ? path.substring(0, path.length - 1) : path;
	}
}

export function notifierServerAddress(): string {
	if (location.hostname === 'localhost') {
		return `http://localhost:8090`;
	} else {
		let path = getAssetPath('..');
    path = path !== '/' && path.endsWith('/') ? path.substring(0, path.length - 1) : path;

		return `${path}/notifier`;
	}
}

export function registerCssAsset(asset: string) {
	const varName = '--asset-url-' + asset.replace(/[^a-zA-Z0-9_-]/g, '-');
	const assetPath = getAssetPath('../assets/' + asset);
	document.documentElement.style.setProperty(varName, `url('${assetPath}')`);
}

export function rootUrl(): string {
  let url: string = 'https://' + location.hostname;

  if (location.port) {
	  url += ':' + location.port;
  }

  return url;
}

export function formatPrice(price:number):string {
    return price.toLocaleString('de-AT', {minimumFractionDigits: 2})
}

export function formatFileSize(length: number): string {
  if (length <= 1024 * 1024) {
    return (length / 1024).toFixed(3) + " KB";
  } else {
    return (length / 1024 / 1024).toFixed(3) + " MB";
  }
}

export function getLangValue(values: any): any {
  if (values.de) {
    return values.de
  }
}

export function getObjectByKeyValue(objArray: any[], key: string, value: string) {
  return objArray.find(obj => obj[key] === value)
}

export function removeObjByKeyValue(objArray: any[], key: string, value: string) {
  return objArray.filter(function (obj) {
    return obj[key] !== value;
  });
}

export function validateEmail(email: string) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export function round(input: number, decimalPlaces: number = 0, base: number = 10) {
  const roundingFactor = Math.pow(base, decimalPlaces);
  return Math.round(input * roundingFactor) / roundingFactor;
}

export function manipulateLangNav() {


  let langItems: NodeList = document.querySelectorAll("ul.lang-nav > li > a")

  langItems.forEach((item: Node) => {

    let linkItem: HTMLLinkElement = item as HTMLLinkElement
    if (linkItem.href.indexOf("#") > -1) {
      linkItem.href = linkItem.href.substring(0, linkItem.href.indexOf("#")) + location.hash;
    } else {
      linkItem.href = linkItem.href + location.hash;
    }

    // console.log()
  });
}

export function getPrivacyPolicyLink(lang: string): string {
  switch (lang) {
      case "de":
          return "https://www.oebb.at/static/tarife/de/datenschutzerklaerung/index.html";
      default:
          return "https://www.oebb.at/static/tarife/en/data_privacy_statement/index.html";
  }
}

export function getGeneralTermsAndConditionsLink(lang: string): string {
  switch (lang) {
      case "de":
          return "https://www.oebb.at/static/tarife/de/index.html";
      default:
          return "https://www.oebb.at/static/tarife/en/index.html";
  }
}
